import * as Yup from 'yup';
import {IModel} from '~/lib/model';

export interface IBidderCapping extends IModel {
    limit: number;
    test: boolean;
}

export const BidderCappingSchema = Yup.object().required().shape<IBidderCapping>({
    id: Yup.number().nullable(),
    limit: Yup.number().required(),
    test: Yup.boolean().required()
});

export const defaultCapping: IBidderCapping = {
    id: null,
    limit: 100,
    test: false
};
